module.exports = "<div class=\"headerDisplay\">\r\n  <div (click)=\"params.enableSorting && onSortRequested($event)\">\r\n    <div class=\"{{params.headerClass}}\" title=\"{{params.displayName}}\">{{params.displayName}}\r\n      <i [hidden]=\"!params.enableSorting\" class=\"fa {{(this.sorted === 'desc' ? 'fa-sort-desc' : (this.sorted === 'asc' ? 'fa-sort-asc' : 'fa-sort'))}}\"></i>\r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/assorted/grid-header.component.html
// module id = ./src/app/shared/components/assorted/grid-header.component.html
// module chunks = main